module.exports = __webpack_public_path__ + "assets/img/help_image03-3.74e453c4.png";